import React, { useState, useEffect } from "react";

import Spinner from "../../components/Spinner";

import { eventTrack, eventTrackGA4 } from "../../utils/helperFunctions";
import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const SubscribeForm = ({ status, message, onValidated }) => {
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (status === CONSTANTS.success) clearFields();
  }, [status]);

  const clearFields = () => {
    setEmail("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    email &&
      email.indexOf("@") > -1 &&
      onValidated({
        MERGE0: email,
      });
  };

  const handleSubscribeEvent = () => {
    eventTrack("MailChimp Subscriber", "User has subscribed to mailchimp", "Subscribers");
    eventTrackGA4("MailChimp Subscriber", "User has subscribed to mailchimp", "Subscribers");
  };

  const validateInput = (values) => {
    return values.some((value) => value === "") || values[0].indexOf("@") === -1;
  };

  return status === "sending" ? (
    <Spinner />
  ) : (
    <form className="mailchimp-form" onSubmit={(e) => handleSubmit(e)}>
      <div className="form-items">
        <div className="email-field">
          <input
            label="Email"
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            value={email}
            className="text-field"
            placeholder="Enter your email here"
            required
          />
        </div>
        <div className={`${status}`} dangerouslySetInnerHTML={{ __html: message }} />

        <p className="terms-text">
          I agree to receiving emails from Omni-Active® Fitness. If I live outside the United States, I consent to my
          information being transferred to Omni-Active® Fitness
        </p>
        <div className="submit">
          <input
            className="submit-btn"
            label="subscribe"
            value="Join Us"
            type="submit"
            onClick={handleSubscribeEvent}
            disabled={validateInput([email])}
          />
        </div>
      </div>
    </form>
  );
};

export default SubscribeForm;
